// ──────────────────────────────────────────────
// localStorage wrapper — ready for Supabase migration
// ──────────────────────────────────────────────

const PREFIX = "conf_app_";

function getKey(key: string): string {
  return `${PREFIX}${key}`;
}

export const storage = {
  get<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(getKey(key));
      return raw ? (JSON.parse(raw) as T) : fallback;
    } catch {
      return fallback;
    }
  },

  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(getKey(key), JSON.stringify(value));
    } catch {
      // quota exceeded — silent fail in MVP
    }
  },

  remove(key: string): void {
    localStorage.removeItem(getKey(key));
  },

  clear(): void {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => localStorage.removeItem(k));
  },
};

// ──────────────────────────────────────────────
// Typed helpers
// ──────────────────────────────────────────────

export const KEYS = {
  SELECTED_EVENT: "selectedEventId",
  ONBOARDING_DONE: "onboardingDone",
  SCAN_HISTORY: "scanHistory",
  SAVED_CONTACTS: "savedContacts",
  USER_PROFILE: "userProfile",
  /** Legacy device-wide flag (migrated into CAMERA_GRANTED_USERS). */
  CAMERA_GRANTED: "cameraGranted",
  /** Per-user map: { [userId]: true }. */
  CAMERA_GRANTED_USERS: "cameraGrantedUsers",
  SEARCH_RECENT_BY_EVENT: "searchRecentByEvent",
} as const;